export default __webpack_public_path__ + "static/media/icon_grievance-redressal.2a927f67.svg";